import ExtrasSubscriptions from './ExtrasSubscriptions';

export default ExtrasSubscriptions;
